import { render } from "./QuestionCategory.vue?vue&type=template&id=2d095c3c&scoped=true&ts=true"
import script from "./QuestionCategory.vue?vue&type=script&lang=ts"
export * from "./QuestionCategory.vue?vue&type=script&lang=ts"

import "./QuestionCategory.vue?vue&type=style&index=0&id=2d095c3c&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d095c3c"]])

export default __exports__